<app-dashboard>
    <div class="w-full flex flex-col p-[20px]">
        <div class="w-full mb-[20px]"><span class="font-[500] text-[20px] text-slate-600">Welcome,  <span class="text-[24px] font-[600] text-slate-800">{{myData?.user?.organizations[0]?.name}}</span></span></div>
        <div class="w-full gap-[20px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[14px] font-[500]"> Vault Records</span>
                <span class="text-[30px] font-[800] text-slate-900">12</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[14px] font-[500]">Tokenization Count</span>
                <span class="text-[30px] font-[800] text-slate-900">49</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[14px] font-[500]">Relay requests</span>
                <span class="text-[30px] font-[800] text-slate-900">26</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[14px] font-[500]">Relay duration (ms)</span>
                <span class="text-[30px] font-[800] text-slate-900">20</span>
            </div>
        </div>

   <div class="w-full flex flex-col mt-[20px]"> 
    <!-- <span class="text-slate-800 text-[20px] font-[500]">Surveillance</span> -->
    <!-- <p-chart type="bar" [data]="basicData" [options]="basicOptions" /> -->
    <div class="w-full flex flex-col lg:grid lg:grid-cols-2 gap-[20px]">
       
          <!-- <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Processing Time</span>
            <canvas id="lineChart1"></canvas>
          </div>
          <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Relay Count</span>
            <canvas id="barChart"></canvas>
          </div>
          <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Response Status Codes</span>
            <canvas id="lineChart2"></canvas>
          </div> -->
          <!-- <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Domain Processing Time</span>
            <canvas id="lineChart3"></canvas>
          </div>
          <div class="w-full col-span-2 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Domain Processing Time</span>
            <canvas id="lineChart4"></canvas>
          </div> -->
      </div>
   </div>
    </div>
</app-dashboard>
